var map = {
	"./Backrooms.png": 2023,
	"./BambooForest.png": 6559,
	"./BrickMaze.png": 586,
	"./Carnival.png": 3321,
	"./Castle.png": 4640,
	"./Cornfield.png": 1182,
	"./Crypts.png": 2236,
	"./DeadForest.png": 9756,
	"./FogCity.png": 6127,
	"./Forest.png": 6338,
	"./Jungle.png": 8082,
	"./KeptHedges.png": 5654,
	"./Manor.png": 3981,
	"./Mines.png": 8105,
	"./Sewers.png": 9365,
	"./SnowyHedges.png": 1469,
	"./Swamp.png": 903,
	"./Trenches.png": 2289,
	"./UnkeptHedges.png": 1294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2718;